module.exports = __webpack_public_path__ + "img/West_Lothian.b05c11e4.png";